import axios from 'axios'
// import qs from 'qs'

export const emailService = ({
  getTemplateList (token, templateType) {
    return axios.get('/api/EmailTemplates?templateType=' + templateType, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getTemplateText (token, emailTemplateId) {
    return axios.get('/api/EmailTemplate/Text?emailTemplateId=' + emailTemplateId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getSenderEmailList (token) {
    return axios.get('/api/GetSenderEmails', {headers: {'Authorization': 'Bearer ' + token}})
  },
  getViewSentEmails (token, formDataObj) {
    return axios.post('api/ViewSentEmails', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  SendGroupMail (token, formDataObj) {
    return axios.post('api/SendGroupMail', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  sendProgressionMail (token, formDataObj) {
    return axios.post('api/SendProgressionMails', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  sendEmailDashboardMail (token, formDataObj) {
    return axios.post('api/SendUsersProgressionEmail', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  previewEmailBeforeSendDashboardEmail (token, dataObj) {
    return axios.post('api/PreViewEmail', dataObj, {headers: {'Authorization': 'Bearer ' + token, 'Content-Type': 'application/json'}})
  },
  scheduleEmailDashboardMail (token, formDataObj) {
    return axios.post('api/ProgressionReportTask', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  },
  getAllScheduledDashboardEmails (token, flagToPass) {
    return axios.get('api/ReportingTask/ListAll?isProgressionEmailTasks=' + flagToPass, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteScheduledDashboardEmail (token, reportingTaskId) {
    return axios.delete('api/ReportingTask/Delete?reportingTaskId=' + reportingTaskId, {headers: {'Authorization': 'Bearer ' + token}})
  },
  deleteAttachedScheduledDashboardEmailAttachment (token, objToPost) {
    return axios.put('api/UpdateAttachments', objToPost, {headers: {'Authorization': 'Bearer ' + token}})
  },
  updateScheduleEmailDashboardMail (token, formDataObj) {
    return axios.put('api/ProgressionReportTask', formDataObj, {headers: {'Authorization': 'Bearer ' + token}})
  }
})



// WEBPACK FOOTER //
// ./src/server-util/email-service.js